import { computed } from 'vue';
import UserStatus from '@nuxt-common/util/app/utils/cookie/UserStatus.js';
import { useGetAllListsStore } from '#stores/getAllLists';
import { getUserGuid } from '#utils/UserDetails';
import { headers } from 'config';

export default function useWishlists() {
  const allListsStore = useGetAllListsStore();
  const userListsModuleState = computed(() => allListsStore.allListsOfUser);
  const userDetails = computed(() => userListsModuleState.value?.user);
  const allWishlists = computed(() => userListsModuleState.value?.list || []);
  const defaultWishlist = computed(() => allWishlists.value?.find((item) => item.defaultList));
  const defaultWishlistGuid = computed(() => defaultWishlist.value?.listGuid);
  const userFirstName = computed(() => userDetails.value?.profile?.firstName);
  const wishlistsLoading = computed(() => allListsStore.loadingState);
  const isGuestUser = computed(() => userDetails.value?.guestUser);
  const numberOfWishlists = computed(() => allWishlists.value?.length || 0);
  const isAuthenticated = computed(() => UserStatus.isSignedIn());

  const wishlistFetchParams = {
    listLimit: 30,
  };

  const getAllWishlists = async () => {
    if (getUserGuid()) {
      return allListsStore.getUserLists({
        ...wishlistFetchParams,
        headers,
      });
    }
    return null;
  };

  return {
    getAllWishlists,
    userDetails,
    allWishlists,
    defaultWishlist,
    defaultWishlistGuid,
    userFirstName,
    wishlistsLoading,
    isGuestUser,
    numberOfWishlists,
    isAuthenticated,
  };
}
